import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn.ts";

export type SectionTitleProps = HTMLAttributes<HTMLDivElement>;

export function SectionTitle({
  className,
  children,
  ...props
}: SectionTitleProps) {
  return (
    <div
      className={cn(
        "mb-2 text-[11px] font-bold uppercase tracking-widest text-[var(--sf-text-muted)]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
